import { Checkbox } from "@/components/ui/checkbox";
import { useId } from "react";

export interface WorkReviewRequest {
  requestTypes?: string[];
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  deliveryInstructions?: string | null;
}

export function requiresSameWorkReview(request: WorkReviewRequest) {
  return Boolean(
    request.requestTypes?.some(
      (type) => type.includes("CONTACT") || type.includes("INSTRUCTIONS")
    )
  );
}

export function ShipmentWorkReview({
  request,
  checked,
  onCheckedChange,
  disabled,
}: {
  request: WorkReviewRequest;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const id = useId();
  if (!requiresSameWorkReview(request)) return null;
  return (
    <div className="space-y-3 rounded border p-3 text-sm">
      <p className="font-medium">Review contact and instruction impact</p>
      <dl className="space-y-1">
        {(
          [
            ["Contact name", request.contactName],
            ["Contact phone", request.contactPhone],
            ["Contact email", request.contactEmail],
            ["Instructions", request.deliveryInstructions],
          ] as const
        ).map(([label, value]) =>
          value != null ? (
            <div key={label}>
              <dt className="font-medium">{label}</dt>
              <dd className="whitespace-pre-wrap break-words">
                {value === "" ? "Clear this value" : value}
              </dd>
            </div>
          ) : null
        )}
      </dl>
      <div className="flex items-start gap-2">
        <Checkbox
          id={id}
          checked={checked}
          disabled={disabled}
          onCheckedChange={(value) => onCheckedChange(value === true)}
        />
        <label htmlFor={id}>
          I reviewed these contact and instruction edits. They only clarify the
          work in this proposal and add no recipient-authority, timing, service,
          handling or capacity requirements.
        </label>
      </div>
      <p className="text-muted-foreground">
        If these edits introduce new requirements, use the corresponding
        correction or replanning flow, or mark the request cannot fulfill.
        Confirm again when applying a delayed correction.
      </p>
    </div>
  );
}
